// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parameters_tab__YmAo0 {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.parameters_header-wrapper__8034b {
  display: grid;
  grid-template-rows: 1fr min-content;
  gap: 4px;
}

.parameters_header__IoJsa {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.parameters_report__znMqc {
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr;
  gap: 4px;
}

.parameters_custom-active-tab__jjn46 {
  height: 40px;
  border-bottom: 3px solid var(--primary-text-color);
  cursor: pointer;
}

.parameters_custom-tab__\\+4V\\+Q {
  height: 40px;
  cursor: pointer;
}

.parameters_dropdown__OFJ4U {
  max-width: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/parameters/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".tab {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.header-wrapper {\n  display: grid;\n  grid-template-rows: 1fr min-content;\n  gap: 4px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.report {\n  display: grid;\n  align-items: center;\n  grid-template-columns: auto 1fr;\n  gap: 4px;\n}\n\n.custom-active-tab {\n  height: 40px;\n  border-bottom: 3px solid var(--primary-text-color);\n  cursor: pointer;\n}\n\n.custom-tab {\n  height: 40px;\n  cursor: pointer;\n}\n\n.dropdown {\n  max-width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab": `parameters_tab__YmAo0`,
	"header-wrapper": `parameters_header-wrapper__8034b`,
	"header": `parameters_header__IoJsa`,
	"report": `parameters_report__znMqc`,
	"custom-active-tab": `parameters_custom-active-tab__jjn46`,
	"custom-tab": `parameters_custom-tab__+4V+Q`,
	"dropdown": `parameters_dropdown__OFJ4U`
};
export default ___CSS_LOADER_EXPORT___;
